<template>
  <el-dialog
    append-to-body
    width="500px"
    :title="isChange ? '编辑' : '新增锁价'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    @open="handleOpen"
    center
  >
    <el-form
      ref="elFormDom"
      label-position="right"
      label-width="100px"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      class="center-form"
    >
      <el-form-item label="商品名称:" prop="good_name" class="center-item">
        <el-select
          v-if="!isChange"
          v-model="form.data.good_name"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          @change="handleGoodSelect"
          :loading="selLoading"
          value-key="id"
        >
          <el-option
            v-for="item in goodArr"
            :label="item.good_name"
            :value="item"
            :key="item.id"
            :disabled="item.sold_out == 1 ? true : false"
          >
            <div class="flex" style="justify-content: space-between">
              <div>
                <span style="float: left">{{ item.good_name }}</span>
              </div>
              <span style="color: #8492a6; font-size: 13px"
                >{{ item.unit_name }} / {{ item.name }}</span
              >
            </div>
            <div style="color: #999; margin-top: -5px" v-if="!!item.norm_name">
              标名：{{ item.norm_name }}
            </div>
          </el-option>
        </el-select>
        <span v-else>{{ currentRow.goods_name }}</span>
      </el-form-item>
      <el-form-item label="单位:" prop="unit_name" class="center-item">
        {{ form.data.unit_name }}
      </el-form-item>
      <el-form-item label="规格:" prop="name" class="center-item">
        {{ form.data.name }}
      </el-form-item>
      <el-form-item label="锁定金额:" prop="amount" class="center-item">
        <el-input
          v-money
          size="mini"
          v-model.trim="form.data.amount"
          placeholder="请输入"
          clearable
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      form: {
        loading: false,
        data: {
          supplier_id: "",
          amount: "",
          spec_id: "",
          unit_name: "",
          name: "",
        },
        rules: {
          good_name: [
            {
              required: true,
              message: "请选择商品",
              trigger: "change",
            },
          ],
          amount: [
            {
              required: true,
              message: "请输入锁定金额",
              trigger: "change",
            },
          ],
        },
      },
      goodArr: [], // 商品列表
      selLoading: false,
      currentRow: null,
    };
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        let _params = {
          page: 1,
          count: 1000,
          status: 1,
          good_name: query,
          // merchant_id: this.form.data.supplier_id,
          // address_id: this.form.data.address_id,
        };
        this.selLoading = true;
        this.$http
          .get("/admin/goods/specList", { params: _params })
          .then((res) => {
            if (res.code === 1) {
              this.goodArr = res.data.list;
            }
          })
          .finally(() => {
            this.selLoading = false;
          });
      } else {
        this.goodArr = [];
      }
    },
    handleGoodSelect(item) {
      console.log(item);
      this.form.data.unit_name = item.unit_name;
      this.form.data.name = item.name;
      this.form.data.spec_id = item.id;
    },
    reset(done) {
      this.currentRow = null;
      this.form.data = {
        supplier_id: "",
        amount: "",
        spec_id: "",
        unit_name: "",
        name: "",
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    close() {
      this.toggle(false);
    },
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.elFormDom.clearValidate();
      });
    },
    getDetail(row) {
      this.currentRow = row;
      if (this.isChange) {
        this.form.data.good_name = row.goods_name;
        this.form.data.amount = row.amount;
        this.form.data.unit_name = row.unit_name;
        this.form.data.name = row.spec_name;
      }
    },
    confirm() {
      console.log(this.currentRow);
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (this.isChange) {
            this.eddConfirm();
          } else {
            this.addConfirm();
          }
        }
      });
    },
    addConfirm() {
      console.log(this.currentRow);
      let params = {
        spec_id: this.form.data.spec_id,
        supplier_id: this.currentRow.id,
        amount: this.form.data.amount,
        lock_start: this.currentRow.lock_start,
        lock_end: this.currentRow.lock_end,
      };
      this.form.loading = true;
      this.$http
        .post("/admin/lock/createOrUpdate", params)
        .then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.$emit("confirm");
            this.toggle(false);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
    eddConfirm() {
      let params = {
        id: this.currentRow.id,
        spec_id: this.currentRow.spec_id,
        supplier_id: this.currentRow.supplier_id,
        amount: this.form.data.amount,
        lock_start: this.currentRow.lock_start,
        lock_end: this.currentRow.lock_end,
      };
      this.form.loading = true;
      this.$http
        .post("/admin/lock/createOrUpdate", params)
        .then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.$emit("confirm");
            this.toggle(false);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
  },
  computed: {
    isChange() {
      return this.currentRow && this.currentRow.supplier_id;
    },
  },
};
</script>

<style scoped>
.center-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-item {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.el-select,
.el-date-picker {
  width: 100%;
}
</style>

